import { memo } from "react";
import type { RedemptionPosition } from "@/services";
import { RedemptionPositionItem } from "./RedemptionPositionItem";

interface RedemptionPositionsListProps {
    positions: RedemptionPosition[];
}

const TABLE_HEADERS = ["Redemption", "Queue position", "ETA", "Claimable", "Action"];

export const RedemptionPositionsList = memo(function RedemptionPositionsList({
    positions,
}: RedemptionPositionsListProps) {
    return (
        <div className="table-container overflow-x-auto rounded-lg border border-portfolio-positions-table shadow-portfolio-positions-table">
            <table className="w-full min-w-full border-collapse">
                <thead>
                    <tr className="bg-portfolio-positions-table-header text-left text-portfolio-positions-table-header text-[12px] leading-[12px] font-normal">
                        {TABLE_HEADERS.map((header) => (
                            <th key={header} className={`p-4 ${header === "Action" ? "text-right" : ""}`}>
                                {header}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="bg-portfolio-positions-table-body">
                    {positions.map((position, index) => (
                        <RedemptionPositionItem
                            key={`${position.status}-${position.queuePosition}-${index}`}
                            position={position}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    );
});

RedemptionPositionsList.displayName = "RedemptionPositionsList";
